// Unlink, leave, or delete — the three "get rid of it" levels and what each
// actually affects. Sourced from specs/cli.md §5.

import { IconDoorExit, IconLinkOff, IconTrash } from "@tabler/icons-react";
import { CommandLine } from "@/components/command-line";
import { DocSection, K, P, Points } from "../doc-ui";

export function RemoveVaultDoc() {
  return (
    <>
      <P>
        "Remove a vault" can mean three different things. Pick the level that matches what you
        want: stop syncing on one machine, stop being a member, or destroy the vault for everyone.
      </P>

      <DocSection
        icon={IconLinkOff}
        title="Unlink — this machine only"
        description="The folder stays; it just stops syncing."
      >
        <CommandLine command="cairn vault unlink <path>" />
        <P>
          The local folder remains a normal Obsidian vault with all its files. The remote vault,
          other devices, and your membership are untouched. Re-link or re-clone any time.
        </P>
      </DocSection>

      <DocSection
        icon={IconDoorExit}
        title="Leave — your membership"
        description="The vault keeps existing for everyone else."
      >
        <CommandLine command="cairn vault leave <vault>" />
        <Points>
          <li>The vault disappears from your list; other members are unaffected.</li>
          <li>
            If you're the only owner you can't leave — add another owner first (see{" "}
            <em>Share a vault &amp; manage members</em>).
          </li>
          <li>An owner can also remove you: <K>cairn vault remove</K> or the web Members panel.</li>
        </Points>
      </DocSection>

      <DocSection
        icon={IconTrash}
        title="Delete — the whole vault, for everyone"
        description="Owners only. The CLI asks for confirmation unless you pass --yes."
      >
        <CommandLine command="cairn vault delete <vault>" />
        <Points>
          <li>The vault disappears for every member and its server storage is scheduled for
            cleanup.</li>
          <li>
            Local folders on people's machines are <em>not</em> deleted — they stop syncing and
            keep their files as-is. Unlink them separately if you want a clean plugin state.
          </li>
        </Points>
      </DocSection>
    </>
  );
}
